import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  ChatConversationDetailsDto,
  ChatConversationDto,
  type ChatConversationInformation,
  type ChatConversationPresentation,
  type ChatConversationPresentationAdapter,
} from 'ias-ppr-mt-chat-client';

@Injectable()
export class AscupChatConversationPresentationAdapter implements ChatConversationPresentationAdapter {
  public present(
    conversation: ChatConversationDto,
  ): ChatConversationPresentation {
    return conversation.presentation;
  }

  public getListOrder(conversation: ChatConversationDto): number {
    return conversation.sortOrder;
  }

  public loadInformation(
    conversation: ChatConversationDetailsDto,
  ): Observable<ChatConversationInformation> {
    return of(conversation.information);
  }
}
